import { Line, Bar, Pie, Doughnut } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js"

// Register ChartJS components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend, Filler)

const Chart = ({ type, data, options, height }) => {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
    },
  }

  const mergedOptions = { ...defaultOptions, ...options }

  const renderChart = () => {
    switch (type) {
      case "line":
        return <Line data={data} options={mergedOptions} />
      case "bar":
        return <Bar data={data} options={mergedOptions} />
      case "pie":
        return <Pie data={data} options={mergedOptions} />
      case "doughnut":
        return <Doughnut data={data} options={mergedOptions} />
      default:
        return <Line data={data} options={mergedOptions} />
    }
  }

  return <div style={{ height: height || "300px", width: "100%" }}>{renderChart()}</div>
}

export default Chart
